module.exports = __webpack_public_path__ + "static/media/indoair.eb31f127.png";